import React from 'react';
import { Users, Shield } from 'lucide-react';
import { Company, User } from '../types';
import { useUsers } from '@/core/api/queries/users';
import { useCompanies } from '@/core/api/queries/companies';

export const Stats: React.FC = () => {
  const companies = useCompanies();
  const companiesData = (companies.data as Company[]) || [];

  const users = useUsers();
  const usersData = (users.data as User[]) || [];
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-blue-100">Total Companies</p>
            <p className="text-3xl font-bold">{companiesData.length}</p>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-green-100">Total Users</p>
            <p className="text-3xl font-bold">{usersData.length}</p>
          </div>
          <Users size={32} className="text-green-200" />
        </div>
      </div>
      <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-purple-100">Admins</p>
            <p className="text-3xl font-bold">
              {usersData.filter((u: any) => u.role === 'admin' || u.role === 'super_admin').length}
            </p>
          </div>
          <Shield size={32} className="text-purple-200" />
        </div>
      </div>
    </div>
  );
};
